module.exports = __webpack_public_path__ + "resources/img/img_cheating_detection.a04be4e0cee075c0775aa7c875075fad.png";